export const SliderArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 18 28" fill="none">
      <path
        d="M10.7997 14L0.0663394 3.26667L3.33301 -6.11959e-07L17.333 14L3.33301 28L0.0663384 24.7333L10.7997 14Z"
        fill="#283897"
      />
    </svg>
  )
}
